// src/components/forms/shared/ShippingCostInput.tsx
// Componente reutilizable para input de costo de envío
// Usado por: OrderForm y CotizacionForm

import React from 'react'
import { Input } from '../../ui'
import { FormField } from '../../ui/Form'

interface ShippingCostInputProps {
  value: string
  onChange: (value: string) => void
  mode: 'view' | 'edit' | 'create'
  errors?: { [key: string]: string }
  errorKey?: string
  label?: string
}

export const ShippingCostInput: React.FC<ShippingCostInputProps> = ({
  value,
  onChange,
  mode,
  errors = {},
  errorKey = 'costo_envio',
  label = 'Costo de Envío'
}) => {
  const error = errors[errorKey]

  return (
    <FormField
      label={label}
      error={error}
    >
      <Input
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        readOnly={mode === 'view'}
        error={!!error}
        errorMessage={error}
        mode={mode}
      />
    </FormField>
  )
}
